import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import App from './App';
import './index.css';
import { initThemeBeforeRender } from './hooks/useTheme';

initThemeBeforeRender();

function scheduleTelemetryInit() {
  const loadTelemetry = () => {
    void import('./telemetry').then(({ initTelemetry }) => initTelemetry());
  };
  const win = window as Window & {
    requestIdleCallback?: (cb: IdleRequestCallback, opts?: IdleRequestOptions) => number;
  };

  if (typeof window === 'undefined') {
    return;
  }

  if (typeof win.requestIdleCallback === 'function') {
    win.requestIdleCallback(() => loadTelemetry(), { timeout: 3000 });
    return;
  }

  globalThis.setTimeout(loadTelemetry, 1500);
}

scheduleTelemetryInit();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
